'use client';

import FilterIcon from '@repo/ui/src/components/Icons/FilterIcon';
import { useState } from 'react';
import useTranslation from '@repo/ui/src/context/Translation/useTranslation';
import FilterDrawer from './_FilterDrawer';

interface FilterOption {
  title: string;
  filter: string;
  count: number;
}

interface FilterGroup {
  title: string;
  filterType: string;
  options: Array<FilterOption>;
}

interface GridHeaderProps {
  filters?: Array<FilterGroup>;
  currentFilters: Record<string, Array<string>>;
  setFilters: (filter: { filterType: string; filterName: string }) => void;
  clearFilters: () => void;
  nbHits: number;
}

const GridHeader = ({
  filters,
  currentFilters,
  setFilters,
  clearFilters,
  nbHits,
}: GridHeaderProps) => {
  const [filtersOpen, setFiltersOpen] = useState(false);
  const { t } = useTranslation();

  return (
    <div className="flex items-center justify-between py-4 px-8">
      <div>
        {filters && (
          <>
            <button onClick={() => setFiltersOpen(true)} className="tra-text-web-body-xl">
              <FilterIcon aria-hidden className="mr-[1ch]" />
              {t('recipeCategory.filters', undefined, { default: 'Filters' })}
            </button>
            <FilterDrawer
              open={filtersOpen}
              onClose={() => setFiltersOpen(false)}
              filters={filters}
              currentFilters={currentFilters}
              setFilters={setFilters}
              clearFilters={clearFilters}
            />
          </>
        )}
      </div>
      <h2 className="tra-text-web-body-xl normal-case">
        {t(
          'recipeCategory.results',
          { count: nbHits || 0 },
          { default: '{{count}} Result' + (nbHits === 1 ? '' : 's') },
        )}
      </h2>
    </div>
  );
};

export default GridHeader;
